@if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
  <div>
    <h4>{{'ITEM.DETAIL.DUPLICATE_ITEM' | translate}}</h4>
    <button mat-raised-button
      color="primary"
      (click)="onDuplicateArchive()">
      {{'COMMON.LABEL.DUPLICATE' | translate}}
    </button>
  </div>
}